import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common, Custom, FormForgotPassword } from "components";
import { useApp, useNavigation, useTheme } from "contexts";
import { Helpers, Routes } from "utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

type Props = {};

export const ForgotPassword = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useApp();
  const { theme } = useTheme();

  const [email, setEmail] = useState<string>("");
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const isForgotPassword = location.pathname.includes("forgot-password");

  const handleGoBack = () => navigate(Routes.home);

  const handleOnSubmit = (email: string, success: boolean) => {
    setEmail(email);
    setIsSuccess(success);
  };

  return (
    <Box pt={theme.spacing.xl}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Box>
                <Stack spacing={theme.spacing.sm}>
                  <Common.Image src={Helpers.getImage("homepage_banner.png")} />
                  <Box
                    sx={{
                      border: 1,
                      overflow: "hidden",
                      mt: theme.spacing.md,
                      px: theme.spacing.lg,
                      pt: theme.spacing.lg,
                      pb: theme.spacing.xxl,
                      borderRadius: theme.border.radius,
                      borderColor: theme.color.primary.accent,
                    }}
                  >
                    <Stack spacing={theme.spacing.sm}>
                      <Stack spacing={theme.spacing.md}>
                        <Custom.Typography
                          size={theme.font.lg}
                          weight={theme.font.bold}
                        >
                          {isForgotPassword
                            ? t.page.forgot_password.header
                            : t.page.account_recovery.header}
                        </Custom.Typography>
                        <Custom.Typography
                          size={theme.font.sm}
                          weight={theme.font.bold}
                        >
                          {isForgotPassword
                            ? isSuccess
                              ? t.page.forgot_password.aftermatch
                              : t.page.forgot_password.subheader
                            : isSuccess
                              ? t.page.account_recovery.aftermatch
                              : t.page.account_recovery.subheader}
                        </Custom.Typography>
                      </Stack>
                      {!isSuccess && (
                        <FormForgotPassword.Form onSubmit={handleOnSubmit} />
                      )}
                      {isSuccess && (
                        <Box textAlign="center">
                          <Box my={theme.spacing.lg}>
                            <Custom.Typography>{email}</Custom.Typography>
                          </Box>
                          <Custom.Button
                            fullWidth
                            variant="contained"
                            onClick={handleGoBack}
                            sx={{ mt: theme.spacing.md }}
                          >
                            {t.action.return_main}
                          </Custom.Button>
                        </Box>
                      )}
                    </Stack>
                  </Box>
                </Stack>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{ display: { sm: "none", md: "unset" } }}
            >
              <Common.Image src={Helpers.getImage("homepage_art.png")} />
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </Box>
  );
};
